<!-- manage-cell-renderer.component.html -->
<ng-container *ngIf="!isGroup">
  <div class="tw-flex tw-justify-between tw-items-center">
    <!-- Delete (link-style) -->
    <button class="tw-text-dt-text-error" type="button" (click)="onDelete()">Delete</button>

    <!-- Edit as New Version / Resume -->
    <ng-container *ngIf="rowData?.status === 'published'; else resumeBtn">
      <!-- View -->
      <app-gloss-button
        style="width: auto; display: inline-flex"
        [options]="{
          text: ('view' | i18n),
          isEnabled: true,
          onClick: onView.bind(this),
          fullClass: 'btn-squared',
        }"
      ></app-gloss-button>

      <app-gloss-button
        style="width: auto; display: inline-flex"
        [options]="{
          text: ('editAsNewVersion' | i18n),
          isEnabled: true,
          onClick: onEditNew.bind(this),
          fullClass: 'btn-squared btn-primary',
        }"
      ></app-gloss-button>
    </ng-container>

    <ng-template #resumeBtn>
      <app-gloss-button
        style="width: auto; display: inline-flex"
        [options]="{
          text: ('resume' | i18n),
          isEnabled: true,
          onClick: onResume.bind(this),
          fullClass: 'btn-squared btn-primary',
        }"
      ></app-gloss-button>
    </ng-template>
  </div>
</ng-container>
